module.exports = __webpack_public_path__ + "img/empty.7ec7cb2e.png";